<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
      {{ accProduct.accProductName }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
      {{ accProduct.accProductSku }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">
      {{ accProduct.accProductTotalPcs }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">
      {{ totalSales }}
    </td>
  </tr>
</template>

<script>
import numbro from '@/utils/numbro';

export default {
  props: {
    accProduct: {
      type: Object,
      required: true,
    },
  },
  computed: {
    totalSales() {
      return numbro(this.accProduct.accProductTotalSales).formatCurrency({
        mantissa: 2,
        spaceSeparated: true,
      });
    },
  },
};
</script>
